"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableCase = void 0;
const lodash_1 = require("lodash");
// only match and replace _v_<number>
const versionRegExp = /_v_[\d]+$/;
/**
 * snakeCase() but handles version number `task_v_2` -> `task_v2`
 */
function tableCase(value = '') {
    return lodash_1.snakeCase(value).replace(versionRegExp, s => s.replace('_v_', '_v'));
}
exports.tableCase = tableCase;
//# sourceMappingURL=tableCase.js.map